import React from 'react';
import { BadgeProps, BadgeVariant } from '../../../types/DesignSystem/Badge';

const variantStyles: Record<BadgeVariant, string> = {
  warning: 'tw-bg-yellow-warning-100 tw-border tw-border-yellow-warning-500 tw-text-blue-900',
  primary: 'tw-bg-white tw-border tw-border-white tw-text-blue-500',
  secondary: 'tw-bg-blue-900 tw-border tw-border-blue-900 tw-text-white',
  disabled: 'tw-bg-grey-100 tw-border tw-border-grey-100 tw-text-grey-500',
};

const Badge: React.FC<BadgeProps> = ({
  variant = 'secondary',
  children,
  className = '',
}) => {
  return (
    <div
      className={`tw-flex tw-items-center tw-gap-2 tw-min-h-7 tw-px-2 tw-py-0.5 tw-rounded-full tw-text-sub-title-label tw-border-0.5 tw-border-solid tw-shrink-0 ${variantStyles[variant]} ${className}`}
    >
      {children}
    </div>
  );
};

export default Badge;
